<mat-accordion>

    <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Participante
            </mat-panel-title>
        </mat-expansion-panel-header>

        <cadastrar-participantes-reuniao #cadastrarParticipantes [reuniao]="reuniao" (onAbertoFormAdicaoParticipante)="onGetAdicionar($event)">
        </cadastrar-participantes-reuniao>
    </mat-expansion-panel>


    <mat-expansion-panel [expanded]="!openFormCadastro"
                         (opened)="listarParticipantes.carregarLista()"
                         (closed)="openFormCadastro = true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Lista de Participantes ( {{reuniao.participantes?.length}} )
            </mat-panel-title>
        </mat-expansion-panel-header>

        <listar-participantes-reuniao #listarParticipantes
            [participantesReuniao]="reuniao.participantes"
            (onAtualizarParticipante)="onGetAdicionar($event); cadastrarParticipantes.atualizarParticipante($event)"
            (onAbertoFormAdicaoParticipante)="onGetAdicionar($event); cadastrarParticipantes.iniciarObjetos()">
        </listar-participantes-reuniao>

    </mat-expansion-panel>

</mat-accordion>

